import axios from 'axios';
import types from './mutations-types';

const actions = {
  async saveRule({ commit }, obj) {
    const response = await axios.post(
      `${process.env.API_ROOT}/alert-rule/${obj.companyId}`,
      { ...obj.data },
      { headers: { 'x-access-token': obj.token } },
    );

    commit('SET_ALERT_ID', response.data);
  },

  async setList({ commit }, obj) {
    const response = await axios.get(
      `${process.env.API_ROOT}/alert-rule/${obj.companyId}`,
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );

    commit(types.SET_LIST, response.data);
  },

  async deleteRule({ commit }, obj) {
    await axios.delete(`${process.env.API_ROOT}/alert-rule/${obj.id}`, {
      headers: {
        'x-access-token': obj.token,
      },
    });
  },

  async updateRule({ commit }, obj) {
    await axios.put(
      `${process.env.API_ROOT}/alert-rule/${obj.id}`,
      {
        ...obj.data,
      },
      {
        headers: { 'x-access-token': obj.token },
      },
    );
  },

  async getBranchRules({ commit }, obj) {
    const response = await axios.get(
      `${process.env.API_ROOT}/branch-alert-rules/${obj.companyId}/${obj.mainRuleId}`,
      {
        headers: { 'x-access-token': obj.token },
        params: { ...obj.params },
      },
    );

    commit('GET_BRANCH_RULES', response.data);
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/settings/alert-rules/actions.js